import { Box, styled, Typography } from '@mui/material';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { round } from 'lodash';

const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.sm),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(theme.spacingSizes.xxs),
  width: '100%',
  backgroundColor: theme.palette.grey[100],
  maxWidth: '400px',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
}));

type Props = {
  sourceCurrency: CurrencyCode;
  targetCurrency: CurrencyCode;
  rate: number;
  className?: string;
};

const CurrencyTransactionRate: React.FC<Props> = ({
  className,
  sourceCurrency,
  targetCurrency,
  rate,
}) => {
  return (
    <Container className={className}>
      <Typography variant="body2" fontWeight="bold">
        Rate at transfer
      </Typography>
      <Typography variant="body2">
        {`1 ${sourceCurrency} = ${round(rate, 6).toFixed(6)} ${targetCurrency}`}
      </Typography>
    </Container>
  );
};

export default CurrencyTransactionRate;
